const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 13/12/16.
 */
const React = require('react');

const {formatText} = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const OtherIncome = require('../OtherIncome/OtherIncome');

class OtherIncomeList extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values.length >= 1) {
            initialState = { otherIncomeValues: this.props.values };
        } else {
            const rows = this.initializeRows();
            initialState = { otherIncomeValues: rows }
        }
        this.state = initialState;
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.buildRows = this.buildRows.bind(this);
    }




    onBlur(event, index) {
        let updateObject = this.state.otherIncomeValues[index];
        updateObject[event.target.name] = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.otherIncomeValues[index] = updateObject;
        this.setState(stateCopy);
    }

    onChange(event, index ) {
        let stateCopy = Object.assign({}, this.state);
        stateCopy.otherIncomeValues[index].periodicity = event.value;
        this.setState(stateCopy);
    }

    buildRows() {
        let rows = [];
        this.state.otherIncomeValues.forEach((option, index) => {
            rows.push(
                <OtherIncome
                    values={option}
                    key={index}
                    rowIndex={index}
                    handleChange={this.onChange}
                    handleBlur={this.onBlur}/>
            )
        });
        return rows;
    }


    initializeRows() {
        let rows = [];
        for (let x = 0; x < this.props.rows; x++) {
            rows.push({
                origin: '',
                periodicity: '',
                amount: ''
            });
        }
        return rows
    }

    render() {
        this.props.dataReceiver(this.state.otherIncomeValues);
        return (
            <Accordion customClassName="laboral-data__accordion" isExpanded={true}>
                <AccordionHeader
                    name="AccordionHeader"
                    isRightArrowPosition={true}>
                    <h4 className="laboral-data__subtitle">{formatText('contractsView-checkingAccountLaboralDataOtherIncomeOtheritle')}</h4>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {this.buildRows()}
                </AccordionBody>
            </Accordion>
        );
    }
}

OtherIncomeList.propTypes = {
    dataReceiver: PropTypes.func,
    values: PropTypes.array,
    rows: PropTypes.number
};

module.exports = OtherIncomeList;